import React, { useEffect } from 'react';
import CustomModal from '../../../components/common/CustomDialog/CustomModal';
import Grid from '../../../components/layout/grid/Grid';
import { CloudUpload } from 'lucide-react';

const UploadModal = ({
    open,
    uploadField,
    selectedFiles,
    setSelectedFiles,
    onClose,
    onSubmit,
    isFormValid,
}) => {
    useEffect(() => {
        return () => {
            selectedFiles.forEach(file => {
                if (file && file.preview) {
                    URL.revokeObjectURL(file.preview);
                }
            });
        };
    }, [selectedFiles]);

    const handleFileChange = (e, index) => {
        const file = e.target.files[0];
        if (!file) return;

        const updatedFiles = [...selectedFiles];
        if (updatedFiles[index]?.preview) {
            URL.revokeObjectURL(updatedFiles[index].preview);
        }

        updatedFiles[index] = {
            file,
            preview: URL.createObjectURL(file),
        };

        setSelectedFiles(updatedFiles);
    };

    const allFilesNull = selectedFiles.every(file => !file || !file.file);

    return (
        <CustomModal
            open={open}
            title={`Upload ${uploadField === 'aadhar_card_number' ? 'Aadhar Card' : 'Pan Card'}`}
            cancelLabel="Cancel"
            submitLabel="Upload"
            disabled={!isFormValid || allFilesNull}
            onCancel={() => {onClose()}}
            onSubmit={onSubmit}
            width="500px"
        >
            <Grid gap={24}>
                {[0, 1].map(index => {
                    const inputName =
                        uploadField === 'aadhar_card_number'
                            ? index === 0
                                ? 'front_aadhar_card_file'
                                : 'back_aadhar_card_file'
                            : index === 0
                                ? 'front_pan_card_file'
                                : 'back_pan_card_file';

                    return (
                        <Grid item xs={12} key={index} className="w-full mt-3">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={e => handleFileChange(e, index)}
                                id={`upload-file-${index}`}
                                name={inputName}
                                className="hidden"
                            />
                            <label
                                htmlFor={`upload-file-${index}`}
                                className="border-2 border-dashed border-gray-300 w-full h-52 flex flex-col justify-center items-center gap-2 cursor-pointer hover:bg-blue-50 transition"
                            >
                                {selectedFiles[index]?.preview ? (
                                    <img
                                        src={selectedFiles[index].preview}
                                        alt="preview"
                                        className="max-h-full max-w-full object-contain"
                                    />
                                ) : (
                                    <>
                                        <CloudUpload className="text-gray-300 w-8 h-8" />
                                        <p className="text-gray-500 text-sm">
                                            {index === 0 ? 'Upload Front Image' : 'Upload Back Image'}
                                        </p>
                                    </>
                                )}
                            </label>
                        </Grid>
                    );
                })}
            </Grid>
        </CustomModal>
    );
};

export default UploadModal;